var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown__current"},[_vm._v("Website testing")]),_vm._l((_vm.questions),function(question){return _c('div',{key:question.index,staticClass:"dropdown__hide"},[_c('router-link',{staticClass:"mt__10",attrs:{"to":question.link}},[_vm._v(_vm._s(question.name))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }